var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconSsnCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-ssn-card_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161164",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31325",
  clipPath: "url(#icon-ssn-card_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38630",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38631",
  d: "M50.574 45.098H13.426a2.556 2.556 0 01-2.556-2.556V21.456a2.556 2.556 0 012.556-2.556h37.148a2.556 2.556 0 012.556 2.556v21.088a2.556 2.556 0 01-2.556 2.556",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38632",
  d: "M13.426 18.079h37.148a3.381 3.381 0 013.377 3.377v21.088a3.381 3.381 0 01-3.377 3.377H13.426a3.381 3.381 0 01-3.377-3.377V21.456a3.381 3.381 0 013.377-3.377m37.148 26.2a1.736 1.736 0 001.734-1.733v-21.09a1.736 1.736 0 00-1.734-1.733H13.426a1.736 1.736 0 00-1.729 1.733v21.088a1.736 1.736 0 001.734 1.733z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38633",
  d: "M10.868 22.757h42.259v-1.4a2.454 2.454 0 00-2.454-2.454H13.324a2.454 2.454 0 00-2.454 2.454z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38634",
  d: "M53.951 23.579h-43.9v-2.225a3.279 3.279 0 013.275-3.275h37.35a3.279 3.279 0 013.275 3.275zm-42.254-1.643h40.612v-.582a1.634 1.634 0 00-1.631-1.631H13.324a1.633 1.633 0 00-1.627 1.631z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38635",
  d: "M15.648 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38636",
  d: "M18.997 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38637",
  d: "M22.343 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38638",
  d: "M28.947 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38639",
  d: "M32.115 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38640",
  d: "M38.526 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38641",
  d: "M41.804 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38642",
  d: "M45.08 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38643",
  d: "M48.356 31.91l.813-.813.649.649-.813.813.846.846-.616.616-.838-.838-.813.813-.649-.649.813-.813-.846-.846.616-.616z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161162",
  fill: "#29398c",
  d: "M24.793 32.08h1.789v1.095h-1.789z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161163",
  fill: "#29398c",
  d: "M34.365 31.999h1.789v1.095h-1.789z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38644",
  d: "M44.237 38.377H19.761a.821.821 0 010-1.642h24.476a.821.821 0 010 1.642",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38645",
  d: "M40.022 41.793H23.977a.821.821 0 010-1.642h16.044a.821.821 0 110 1.642",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38646",
  d: "M53.13 26.743H10.87a.821.821 0 110-1.642h42.26a.821.821 0 010 1.642z",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/icon-ssn-card.18fa267eaf6312b565bb9b5ad8bd6e5a.svg";
export { SvgIconSsnCard as ReactComponent };